import { Box, Skeleton } from '@mui/material';
import Grid from '@mui/material/Grid2';

/**
 * Loading skeleton for the compositions grid (matches card grid layout).
 */
export function CompositionsGridSkeleton() {
  return (
    <Box>
      <Grid container spacing={2}>
        {Array.from({ length: 8 }).map((_, i) => (
          <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }} key={i}>
            <Skeleton variant="rounded" height={240} sx={{ borderRadius: 1 }} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
